<template>
    <div
        class="bo-catalog-sidebar"
        :class="{ 'fixed-sidebar': fixedSidebar }"
    >
        <div class="title">{{ catalogTranslations.categories ?? "Categories" }}</div>
        <div class="sidebar-content">
            <div
                v-if="loading"
                class="category-wrapper"
            >
                <div
                    v-for="n in 4"
                    :key="`category-skeleton-${n}`"
                    class="category-item search-skeleton"
                >
                    <div class="category-text">
                        <div class="skeleton-line short"></div>
                        <div class="skeleton-line"></div>
                    </div>
                </div>
            </div>
            <bo-catalog-category
                v-else
                :categories="categories"
                @select-category="selectProductCategory"
                :current-category-id="currentCategoryId"
            >
            </bo-catalog-category>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
Vue.component("bo-catalog-category", require("js/frontend/components/bo-catalog-category.vue").default);

export default {
    props: {
        fixedSidebar: Boolean,
        categories: {
            type: Array,
            default: "",
        },
        currentCategoryId: {
            type: Number,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            openDropdowns: {},
            catalogTranslations: window.bo?.catalogTranslations ?? {},
            generalTranslations: window.bo?.generalTranslations ?? {},
        };
    },
    methods: {
        selectProductCategory(id) {
            this.$emit("select-category", id);
        },
    },
};
</script>
